"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const ContextSwitcherMobile_1 = require("../context-switcher/ContextSwitcherMobile");
const resources_1 = require("../../resources");
const Sidebar = ({ title, isOpen, isMobile, children, onToggle, appContext, availableContexts, onCtxChange, ...rest }) => {
    const [open, setOpen] = (0, react_1.useState)(isOpen);
    (0, react_1.useEffect)(() => {
        setOpen(isOpen);
    }, [isOpen]);
    return ((0, jsx_runtime_1.jsxs)(SidebarWrapper, { open: open, mobile: isMobile, "data-opened": open, ...rest, children: [(0, jsx_runtime_1.jsxs)(SidebarHeader, { children: [(0, jsx_runtime_1.jsx)(ContextSwitcherMobile_1.ContextSwitcherMobile, { appContext: appContext, availableContexts: availableContexts, onCtxChange: onCtxChange }, void 0), (0, jsx_runtime_1.jsxs)(Title, { children: [title && ((0, jsx_runtime_1.jsx)("div", { children: appContext === "PBP" ? (0, jsx_runtime_1.jsx)(resources_1.LogoPBPSquare, {}, void 0) : (0, jsx_runtime_1.jsx)(resources_1.LogoPMPSquare, {}, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: title }, void 0), (0, jsx_runtime_1.jsx)(Close, { "data-sidebar-close": "true", onClick: () => {
                                    setOpen(!open);
                                    onToggle && onToggle(!open);
                                }, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: open || isMobile
                                        ? ["fas", "caret-left"]
                                        : ["fas", "caret-right"], color: "light-grey", size: isMobile ? "lg" : "1x" }, void 0) }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(SidebarChildren, { "data-sidebar-content": "true", children: children }, void 0)] }, void 0));
};
const SidebarChildren = styled_components_1.default.div `
  grid-row: 2;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 220px;
`;
const Close = styled_components_1.default.div `
  cursor: pointer;
  padding-left: 1rem;
  z-index: 18;
  transition: left 0.4s ease;

  & > div {
    background-color: transparent !important;
    width: auto;
  }
`;
const Title = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  line-height: 1.5rem;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.m} ${theme.spacings.s}`};

  & > div:first-of-type {
    display: inline-block;
    height: 1.5rem;
    margin-right: ${({ theme }) => theme.spacings.xs};
    width: 1.25rem;
  }

  h2 {
    margin: 0;
    flex: 1;
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      display: none;
    }
  }
`;
const SidebarWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-rows: min-content auto;
  position: relative;
  transition: all 0.3s ease-out;
  background: ${({ theme }) => theme.colors.whiteBase};
  height: 100%;
  width: 100%;
  overflow-x: hidden;

  ${Title} {
    margin-top: 0;
    margin-bottom: 0;
  }

    h2 {
      position: relative;
      overflow: hidden;
      span {
        width: 0;
      }
      & > div {
        height: 1rem;
      }
    }
  }
`;
const SidebarHeader = styled_components_1.default.div `
  grid-row: 1;
`;
exports.default = Sidebar;
//# sourceMappingURL=sidebar.js.map